<template>
  <div class="variation-selector">
    <div class="variation-header">
      <span>{{ variationName }}</span>
      <hr/>
    </div>
    <list-view class="variation-container">
      <div class="variation" v-for="variation in variations" v-on:click="variationSelected(variation.value)" v-bind:selected="variation.selected">
        <div class="variation-image"
            v-bind:style="{ backgroundImage: variation.photoUrl }">
        </div>
        <div>{{ variation.name }}</div>
        <div class="variation-price" v-if="variation.price"><span class="price-unit">+NT$</span> {{ variation.price | priceTag }}</div>
      </div>
    </list-view>
  </div>
</template>

<script>
import listView from 'components/list-view';
import Utils from 'utils/utils';

const photoUrlBase = 'static/images/texture_detail/';

export default {
  name: 'variation-selector',
  props: ['name', 'options', 'id', 'value'],
  data() {
    return {};
  },
  components: {
    listView
  },
  computed: {
    variationName() {
      return this.name;
    },
    variations() {
      return this.options.map((option) => {
        return {
          selected: this.value === option.value,
          value: option.value,
          name: option.name,
          price: option.price,
          photoUrl: `url(${photoUrlBase + option.photo_url}.png)`
        };
      });
    }
  },
  filters: {
    priceTag: Utils.priceTag
  },
  methods: {
    variationSelected(variationValue) {
      this.$emit('variation-selected', this.id, variationValue);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
  pointer-events: auto;
}
.variation-selector {
  padding: 10px 20px;
}
.variation-header {
  position: relative;
  height: 22px;
}
.variation-header span {
  position: relative;
  display: inline-block;
  background: white;
  padding-right: 15px;
  z-index: 1;
}
.variation-header hr {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
}
.variation-container {
  /* padding for scrollbar */
  padding-bottom: 5px;
  font-size: 14px;
}
.variation {
  min-width: 80px;
  padding: 5px 10px 15px 10px;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.variation[selected] {
  color: #6DADAD;
}
.variation:hover {
  background: #F0F0F0;
}
.variation-image {
  width: 46px;
  height: 46px;
  border-radius: 23px;
  background: #A9ACA6;
  margin: 10px auto;
  box-sizing: border-box;
  background-size: cover;
}
.variation[selected] .variation-image {
  border: 3px solid #6DADAD;
}
.variation-price {
  margin-top: 5px;
  font-size: 12px;
}
.price-unit {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// variation-selector.vue?124926c6